import { Component, Input, Output, EventEmitter, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import _moment from 'moment';
import { default as _rollupMoment } from 'moment';
import { MY_FORMATS } from '../format/format';

const moment = _rollupMoment || _moment;

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
@Component({
  selector: 'tools-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class DateRangePickerComponent implements OnInit {
  @ViewChild('elementToFocus', { static: false }) _input2: ElementRef;
  @ViewChild('elementToFocuss', { static: false }) _input1: ElementRef;

  @Output() notify: EventEmitter<any> = new EventEmitter<string>();
  @Input() inline = false;
  @Input() startDateHeading: string;
  @Input() endDateHeading: string;
  @Input() defaultStartDate: Date;
  @Input() defaultEndDate: Date;
  @Input() calendarMonthStart = true;
  @Input() time = false;
  @Input() classes = ['default-input'];
  @Input() dateFormat: string;
  startTime = '00:00 AM';
  endTime = '11:59 PM';
  tempMoment = moment();
  _label: any;
  _formats: any;

  startDateControl = new UntypedFormControl();
  startTimeControl = new UntypedFormControl('00:00 AM');
  endTimeControl = new UntypedFormControl('11:59 PM');
  endDateControl = new UntypedFormControl();
  // ThreeMonthControl = moment().subtract(90, 'day')
  endBeforeStart: boolean;
  dateValuesSelected = {
    startDate: null,
    endDate: null,
    valid: null,
  };

  constructor(@Inject(MAT_DATE_FORMATS) formats: MatDateFormats) {
    this._formats = formats;
  }



  openPicker1(picker: MatDatepicker<Date>) {
    picker.open();
    setTimeout(() => this._input1.nativeElement.focus());
  }
  closePicker1(e) {
    setTimeout(() => this._input1.nativeElement.blur());
  }
  startTimeChanged(newTime: string) {
    this.startTime = newTime;
    this.dateSelected();
  }
  endTimeChanged(newTime: string) {
    this.endTime = newTime;
    this.dateSelected();
  }
  openPicker2(picker: MatDatepicker<Date>) {
    picker.open();
    setTimeout(() => this._input2.nativeElement.focus());
  }

  closePicker2(e) {
    setTimeout(() => this._input2.nativeElement.blur());
  }
  ngOnInit() {

    if(this.dateFormat != null){
      this._formats.parse.dateInput = this.dateFormat;
      this._formats.display.dateInput = this.dateFormat;
    }
    this.reset();
  }
  formatStartDate(oldFormat: string): string {
    const theDate: Date = new Date(oldFormat);
    theDate.setHours(2, 0, 0, 0);
    return theDate.toISOString();
  }

  formatEndDate(oldFormat: string): string {
    const theDate: Date = new Date(oldFormat);
    theDate.setDate(theDate.getDate() + 1);
    theDate.setHours(1, 59, 59, 999);
    return theDate.toISOString();
  }

  emitDates() {
    this.dateValuesSelected.startDate = this.formatStartDate(this.startDateControl.value);
    this.dateValuesSelected.endDate = this.formatEndDate(this.endDateControl.value);
    this.notify.emit(this.dateValuesSelected);
  }

  isValid(): boolean {
    const startYear = this.startDateControl.value ? this.startDateControl.value.year : new Date().getFullYear();
    const startMonth = this.startDateControl.value ? this.startDateControl.value.month : new Date().getMonth();
    const startDate = this.startDateControl.value ? this.startDateControl.value.date : new Date().getDate() - 1;
    const endYear = this.endDateControl.value ? this.endDateControl.value.year : new Date().getFullYear();
    const endMonth = this.endDateControl.value ? this.endDateControl.value.month : new Date().getMonth();
    const endDate = this.endDateControl.value ? this.endDateControl.value.date : new Date().getDate();
    if (
      startYear > endYear ||
      (startYear === endYear && startMonth > endMonth) ||
      (startYear === endYear && startMonth === endMonth && startDate > endDate) ||
      (startYear === endYear && startMonth === endMonth && startDate === endDate && !this.startTimeIsBeforeEndTime())
    ) {
      this.endDateControl.markAsTouched();
      this.endDateControl.setErrors({
        notMatched: true,
      });
      return false;
    } else {
      this.endDateControl.markAsTouched();
      this.endDateControl.setErrors(null);
      return true;
    }
  }
  startTimeIsBeforeEndTime() {
    if (this.time && this.startTime != null && this.startTime !== '' && this.startTime != null && this.startTime !== '') {
      const startArr = this.startTime.split(':');
      const startHours = parseInt(startArr[0], 10);
      const startMinutes = parseInt(startArr[1].split(' ')[0], 10);
      const startIsPM = startArr[1].split(' ')[1] === 'PM';
      const endArr = this.endTime.split(':');
      const endHours = parseInt(endArr[0], 10);
      const endMinutes = parseInt(endArr[1].split(' ')[0], 10);
      const endIsPM = endArr[1].split(' ')[1] === 'PM';
      // console.log(startHours, startMinutes, startIsPM, endHours, endMinutes, endIsPM);
      if ((startIsPM && !endIsPM) || (startIsPM === endIsPM && (startHours > endHours || (startHours === endHours && startMinutes > endMinutes)))) {
        return false;
      } else {
        return true;
      }
    }
    return true;
  }
  startOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  }

  reset() {
    this.endBeforeStart = false;
    this.endDateControl = new UntypedFormControl(this.defaultEndDate);
    this.dateValuesSelected = {
      startDate: null,
      endDate: this.defaultEndDate,
      valid: true,
    };
    if (this.calendarMonthStart) {
      const monthStart = this.startOfMonth(this.defaultStartDate);
      this.startDateControl = new UntypedFormControl(monthStart);
      // console.log(this.startDateControl);
      this.dateValuesSelected.startDate = monthStart;
    } else {
      this.startDateControl = new UntypedFormControl(this.defaultStartDate);
      this.dateValuesSelected.startDate = this.defaultStartDate;
    }
    this.emitDates();
  }

  isValidStart(): boolean {
    // if (this.startDateControl.value <= this.ThreeMonthControl) {
    //   this.startDateControl.markAsTouched();
    //   this.startDateControl.setErrors({
    //     notMatched: true
    //   });
    //   return false;
    // }
    if (this.startDateControl.status === 'INVALID') {
      return false;
    }
    return true;
  }

  dateSelected() {
    if (this.isValid() && this.isValidStart()) {
      this.emitDates();
      this.endDateControl.setErrors(null);
    }
  }
  markAsTouched() {
    this.isValid();
    this.endDateControl.markAsTouched();
    this.startDateControl.markAsTouched();
  }
}
